<template>
  <div class="footer">
    <div class="copy-right">
      <div style="width: 150px"></div>
      <div>
        CopyRight©{{ year }} <a href="http://www.rayqee.com/">珠海瑞启智慧科技有限公司</a> 粤ICP备2023115920号-1
      </div>
      <div style="padding-right: 20px">
        技术支持：
        <span style="color: #048cf8; cursor: pointer"
              @click="nav">易奇科技</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      year: "",
    };
  },
  created () {
    this.year = new Date().getFullYear();
  },
  methods: {
    nav () {
      window.open("https://www.eqlee.com/", "_blank");
    },
  },
};
</script>
<style lang="less" scoped>
.copy-right {
  display: flex;
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  text-align: center;
  padding: 10px 0;
}
/* 清除a标签的默认样式 */
a {
  text-decoration: none; /* 去除下划线 */
  color: inherit; /* 继承父元素的颜色 */
  margin: 0; /* 去除外边距 */
  padding: 0; /* 去除内边距 */
}
</style>
